/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckKdsUpdates200Response,
  CheckKdsUpdatesRequest,
  VersionsPost400Response,
  VersionsPostRequest,
} from '../models/index';
import {
    CheckKdsUpdates200ResponseFromJSON,
    CheckKdsUpdates200ResponseToJSON,
    CheckKdsUpdatesRequestFromJSON,
    CheckKdsUpdatesRequestToJSON,
    VersionsPost400ResponseFromJSON,
    VersionsPost400ResponseToJSON,
    VersionsPostRequestFromJSON,
    VersionsPostRequestToJSON,
} from '../models/index';

export interface CheckKdsUpdatesOperationRequest {
    checkKdsUpdatesRequest: CheckKdsUpdatesRequest;
}

export interface VersionsPostOperationRequest {
    versionsPostRequest: VersionsPostRequest;
}

/**
 * 
 */
export class VersionsApi extends runtime.BaseAPI {

    /**
     */
    async checkKdsUpdatesRaw(requestParameters: CheckKdsUpdatesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckKdsUpdates200Response>> {
        if (requestParameters['checkKdsUpdatesRequest'] == null) {
            throw new runtime.RequiredError(
                'checkKdsUpdatesRequest',
                'Required parameter "checkKdsUpdatesRequest" was null or undefined when calling checkKdsUpdates().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/versions/updates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CheckKdsUpdatesRequestToJSON(requestParameters['checkKdsUpdatesRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckKdsUpdates200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async checkKdsUpdates(requestParameters: CheckKdsUpdatesOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckKdsUpdates200Response> {
        const response = await this.checkKdsUpdatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async versionsPostRaw(requestParameters: VersionsPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['versionsPostRequest'] == null) {
            throw new runtime.RequiredError(
                'versionsPostRequest',
                'Required parameter "versionsPostRequest" was null or undefined when calling versionsPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/versions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VersionsPostRequestToJSON(requestParameters['versionsPostRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async versionsPost(requestParameters: VersionsPostOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.versionsPostRaw(requestParameters, initOverrides);
    }

}
